export default "__VITE_ASSET__861b848f__"